export const SET_COLLAPSED = "SET_COLLAPSED";
